import React from "react";
import { useTranslation } from "react-i18next";

import { FilterMenu } from "@common/filterMenu";
import { SortDropDown } from "./sortDropDown";
import { Props } from "./types";
import styles from "./styles.scss";

function Filters(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.filters}>
      <div className={styles.group}>
        <p className={styles.title}>{t("projectResourcesPage.filters.sort")}</p>
        <SortDropDown sort={props.sort} setSort={props.setSort} />
      </div>
      <div className={styles.group}>
        <p className={styles.title}>
          {t("projectResourcesPage.filters.filter")}
        </p>
        <div className={styles.filter}>
          <FilterMenu
            filter={props.filter}
            placeholder={t("projectResourcesPage.filters.defaultFilter")}
            views={[
              "resources",
              "groups",
              "resourceTags",
              "roles",
              "organizationalUnits",
            ]}
            openedViews={["resources"]}
            setFilter={(filter) => {
              props.setFilter({
                ...props.filter,
                ...filter,
                resourceTags: filter.resourceTags,
              });
            }}
          />
        </div>
      </div>
    </div>
  );
}

export { Filters };
